"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountFeatureStateEnum = void 0;
/** Состоянияе фичи учётной записи (пользователя) */
var AccountFeatureStateEnum;
(function (AccountFeatureStateEnum) {
  /** недоступна и невидима */
  AccountFeatureStateEnum[AccountFeatureStateEnum["disabled"] = 0] = "disabled";
  /** доступна */
  AccountFeatureStateEnum[AccountFeatureStateEnum["enabled"] = 1] = "enabled";
  /** недоступна и отображается в интерфейсе для рекламы */
  AccountFeatureStateEnum[AccountFeatureStateEnum["promoted"] = 2] = "promoted";
})(AccountFeatureStateEnum = exports.AccountFeatureStateEnum || (exports.AccountFeatureStateEnum = {}));
